import { LOCAL_STORAGE_KEY_SESSION_KEY } from 'common/constants/constants'

export default (): string | undefined => {
    const sessionKey = localStorage.getItem(LOCAL_STORAGE_KEY_SESSION_KEY)
    return sessionKey === null ? undefined : sessionKey
}
